import React from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";
import scan_button from "../images/scan-button.svg";

export type NoMatchOverlayProps = {
  displayOverlay: boolean;
  handleScan: () => void;
};

export const NoMatchOverlay: React.FC<NoMatchOverlayProps> = ({
  displayOverlay,
  handleScan,
}) => {
  const { getTranslation } = useLocalStorage();

  if (!displayOverlay) {
    return null;
  }

  return (
    <div id="no-match-overlay" className="no-match-overlay">
      <div className="hint h2">
        <span style={{ whiteSpace: "pre-line" }}>
          {`${getTranslation("No_Result_page", "text_1")}\n${getTranslation(
            "No_Result_page",
            "text_2"
          )}\n${getTranslation("No_Result_page", "text_3")}`}
        </span>
      </div>
      {/*
        "Scan again" button. All positioning is inline so no global
        .scan-button CSS rule (position: fixed + right: 32px from base.scss)
        can fight with our anchored layout.
      */}
      <div
        id="no-match-scan-again"
        onClick={handleScan}
        role="button"
        aria-roledescription="scan again button"
        aria-label="Scan again"
        style={{
          position: "absolute",
          left: "50%",
          bottom: "60px",
          transform: "translateX(-50%)",
          width: "60px",
          height: "60px",
          cursor: "pointer",
          zIndex: 2,
        }}
      >
        <img
          src={scan_button}
          alt=""
          style={{ width: "100%", height: "100%", display: "block" }}
        />
      </div>
    </div>
  );
};
